import { useState, useEffect } from 'react'
import { ContentService } from '../services/contentService'

export const useContent = (page) => {
  const [content, setContent] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true)
        const data = await ContentService.getContent(page)
        setContent(data)
        setError(null)
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    loadContent()
  }, [page])

  const updateContent = async (newContent) => {
    try {
      const success = await ContentService.updateContent(page, newContent)
      if (success) {
        setContent(newContent)
      }
      return success
    } catch (err) {
      setError(err.message)
      return false
    }
  }

  const refreshContent = async () => {
    try {
      setLoading(true)
      const data = await ContentService.getContent(page)
      setContent(data)
      setError(null)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return {
    content,
    loading,
    error,
    updateContent,
    refreshContent,
  }
}
